__turbopack_context__.v({
  "imageColumn": "CapabilitiesLongRow-module-scss-module__yMeDoa__imageColumn",
  "includesList": "CapabilitiesLongRow-module-scss-module__yMeDoa__includesList",
  "includesListContent": "CapabilitiesLongRow-module-scss-module__yMeDoa__includesListContent",
  "indexNumber": "CapabilitiesLongRow-module-scss-module__yMeDoa__indexNumber",
  "itemDescription": "CapabilitiesLongRow-module-scss-module__yMeDoa__itemDescription",
  "itemTitle": "CapabilitiesLongRow-module-scss-module__yMeDoa__itemTitle",
  "rolloverImage": "CapabilitiesLongRow-module-scss-module__yMeDoa__rolloverImage",
  "rolloverImageInner": "CapabilitiesLongRow-module-scss-module__yMeDoa__rolloverImageInner",
  "rolloverImageVisible": "CapabilitiesLongRow-module-scss-module__yMeDoa__rolloverImageVisible",
  "row": "CapabilitiesLongRow-module-scss-module__yMeDoa__row",
  "stack-module-0": "CapabilitiesLongRow-module-scss-module__yMeDoa__stack-module-0",
  "stack-module-1": "CapabilitiesLongRow-module-scss-module__yMeDoa__stack-module-1",
  "stack-module-10": "CapabilitiesLongRow-module-scss-module__yMeDoa__stack-module-10",
  "stack-module-11": "CapabilitiesLongRow-module-scss-module__yMeDoa__stack-module-11",
  "stack-module-12": "CapabilitiesLongRow-module-scss-module__yMeDoa__stack-module-12",
  "stack-module-13": "CapabilitiesLongRow-module-scss-module__yMeDoa__stack-module-13",
  "stack-module-14": "CapabilitiesLongRow-module-scss-module__yMeDoa__stack-module-14",
  "stack-module-15": "CapabilitiesLongRow-module-scss-module__yMeDoa__stack-module-15",
  "stack-module-16": "CapabilitiesLongRow-module-scss-module__yMeDoa__stack-module-16",
  "stack-module-17": "CapabilitiesLongRow-module-scss-module__yMeDoa__stack-module-17",
  "stack-module-18": "CapabilitiesLongRow-module-scss-module__yMeDoa__stack-module-18",
  "stack-module-19": "CapabilitiesLongRow-module-scss-module__yMeDoa__stack-module-19",
  "stack-module-2": "CapabilitiesLongRow-module-scss-module__yMeDoa__stack-module-2",
  "stack-module-20": "CapabilitiesLongRow-module-scss-module__yMeDoa__stack-module-20",
  "stack-module-3": "CapabilitiesLongRow-module-scss-module__yMeDoa__stack-module-3",
  "stack-module-4": "CapabilitiesLongRow-module-scss-module__yMeDoa__stack-module-4",
  "stack-module-5": "CapabilitiesLongRow-module-scss-module__yMeDoa__stack-module-5",
  "stack-module-6": "CapabilitiesLongRow-module-scss-module__yMeDoa__stack-module-6",
  "stack-module-7": "CapabilitiesLongRow-module-scss-module__yMeDoa__stack-module-7",
  "stack-module-8": "CapabilitiesLongRow-module-scss-module__yMeDoa__stack-module-8",
  "stack-module-9": "CapabilitiesLongRow-module-scss-module__yMeDoa__stack-module-9",
  "z-base": "CapabilitiesLongRow-module-scss-module__yMeDoa__z-base",
  "z-content": "CapabilitiesLongRow-module-scss-module__yMeDoa__z-content",
  "z-footer": "CapabilitiesLongRow-module-scss-module__yMeDoa__z-footer",
  "z-header": "CapabilitiesLongRow-module-scss-module__yMeDoa__z-header",
  "z-hero": "CapabilitiesLongRow-module-scss-module__yMeDoa__z-hero",
  "z-logo": "CapabilitiesLongRow-module-scss-module__yMeDoa__z-logo",
  "z-logo-effect": "CapabilitiesLongRow-module-scss-module__yMeDoa__z-logo-effect",
  "z-navigation": "CapabilitiesLongRow-module-scss-module__yMeDoa__z-navigation",
  "z-sub": "CapabilitiesLongRow-module-scss-module__yMeDoa__z-sub",
});
